/**
 * @typedef {object} recipe
 * @property {number} cookingTime
 * @property {number} servings
 * @property {string} image
 * @property {string} url
 * @property {string} publisher
 * @property {string} title
 * @property {Array} ingredients
 * @property {string} [key]
 * @property {boolean} bookmarked
 */
export { recipe };
